'use es6';

import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

function makePureComponentClass() {
  if (React.PureComponent) {
    return React.PureComponent;
  }

  return class PureComponent extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }

  };
}

export default makePureComponentClass();